import { CustomAttributeFieldConfig } from 'src/graphql/entities/custom-attributes/field-view-registry/types';
import {
  getKindLikeValueSafely,
  getNonEmptyString,
} from 'src/graphql/entities/custom-attributes/field-view-registry/utils';
import { MultiLineTextEditor, ShortTextEditor } from './text-edit';
import { MultiLineTextView, ShortTextView } from './text-view';

export const SHORT_TEXT_FIELD_CONFIG: CustomAttributeFieldConfig = {
  type: 'short_text',
  editable: true,
  View: ShortTextView,
  Editor: ShortTextEditor,
  decode: (raw) => ({ kind: 'short_text', value: getNonEmptyString(raw) }),
  encode: (value) => getKindLikeValueSafely(value, 'short_text'),
  isEmpty: (value) => !getKindLikeValueSafely(value, 'short_text'),
};

export const MULTI_LINE_TEXT_FIELD_CONFIG: CustomAttributeFieldConfig = {
  type: 'multi_line_text',
  editable: true,
  verticalLayout: true,
  View: MultiLineTextView,
  Editor: MultiLineTextEditor,
  decode: (raw) => ({ kind: 'multi_line_text', value: getNonEmptyString(raw) }),
  encode: (value) => getKindLikeValueSafely(value, 'multi_line_text'),
  isEmpty: (value) => !getKindLikeValueSafely(value, 'multi_line_text'),
};
